import { NodeViewWrapper } from '@tiptap/react';
import React from 'react';
import AnchorIcon from '@wix/da-ds/pkg/Icons/24x24/EditorAnchor';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
import s from './AnchorNodeView.scss';
const AnchorNodeView = (props)=>{
    return /*#__PURE__*/ React.createElement(NodeViewWrapper, {
        "data-drag-handle": "true",
        className: s['root'],
        as: 'span'
    }, /*#__PURE__*/ React.createElement(SimpleTooltip, {
        usePortal: true,
        text: `#${props.node.attrs.id}`,
        hoverDelay: 200,
        listenOnClicks: false
    }, /*#__PURE__*/ React.createElement(AnchorIcon, null)));
};
AnchorNodeView.displayName = 'AnchorNodeView';
export default AnchorNodeView;

//# sourceMappingURL=AnchorNodeView.js.map